<template>
  <hm-col :id="$attrs['id']" cols="12">
    <blockquote :class="['blockquote', `blockquote--${icon}`]">
      <p v-html="text"></p>
      <cite>{{ env('WHITE_LABEL_NAME') || 'Hotelmeister' }}</cite>
    </blockquote>
  </hm-col>
</template>

<script>

import { isNil, isEmpty } from 'lodash';
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'Hint',

  mixins: [GridMixin],

  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: 'default',
    },
  },

  data: function () {
    return {
      quote: 1,
    };
  },

  created: function () {
    this.quote = Math.ceil(Math.random() * 19);
  },

  methods: {
    env: function (name) {
      return process.env[name];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .blockquote {
    padding: 0 2.5rem;
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    justify-items: center;
    align-items: center;
    justify-content: center;
    align-content: center;
    pointer-events: none;

    margin-top: 1rem!important;
    margin-bottom: 2rem!important;

    cite {
      color: $gray;
      position: relative;
      margin-left: 25px;
      &:before {
        position: absolute;
        content: ' ';
        left: -25px;
        width: 20px;
        height: 1px;
        top: calc(50% - 1px);
        background: $mint;
      }
    }

    p {
      margin-top: 5.5rem;
      font-size: 1.7rem;
      text-align: center;
    }

    &::after {
      content:"?";
      top: 0px;
      left: 50%;
      position: absolute;
      font-size: 5rem;
      line-height: 5rem;
      height: 50px;
      transform: translateX(-50%);
      color: $mint;
    }

    &--warn {
      &::after {
        font-family: "Font Awesome 5 Pro";
        font-weight: 300;
        content: "\f071";
        font-size: 4rem;
        color: $orange;
      }
    }

    &--ok {
      &::after {
        font-family: "Font Awesome 5 Pro";
        font-weight: 300;
        content: "\f00c";
      }
    }

    &--lock {
      &::after {
        font-family: "Font Awesome 5 Pro";
        font-weight: 300;
        content: "\f023";
        font-size: 4rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/Hint.vue